// import _ from 'lodash'
import {
  tipsCollection,
} from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import {timestamp, transformDate} from '@/firebase/firebaseHelpers'

export default {
  FETCH_TIPS ({ commit }) {
    return new Promise((resolve, reject) => {
      tipsCollection.where('uid', '==', currentUserId()).get()
        .then((docs) => {
          const tipsArray = []
          docs.forEach((doc) => {
            const tip = doc.data()
            tip.id = doc.id
            tip.sentAt = transformDate(tip.sentAt)
            tip.unread = tip.unread === undefined ? true : tip.unread
            tip.day = tip.day || 0
            tipsArray.push(tip)
          })
          commit('SET_TIPS', tipsArray)
          resolve(tipsArray)
        })
        .catch((error) => { reject(error) })
    })
  },

  ADD_INITIAL_TIP_DELAYED ({ dispatch }) {
    setTimeout(() => {
      const initialTip = {
        uid: currentUserId(),
        sentAt: timestamp(),
        tipName: 'intro_tip',
        day: 1
      }

      return new Promise((resolve, reject) => {
        tipsCollection.add(initialTip)
          .then(() => {
            dispatch('FETCH_TIPS')
          })
          .catch((error) => { reject(error) })
      })
    }, 10000)
  },

  ADD_SECOND_TIP_DELAYED ({ dispatch }) {
    setTimeout(() => {
      const secondTip = {
        uid: currentUserId(),
        sentAt: timestamp(),
        tipName: 'what_now',
        day: 1
      }

      return new Promise((resolve, reject) => {
        tipsCollection.add(secondTip)
          .then(() => {
            dispatch('FETCH_TIPS')
          })
          .catch((error) => { reject(error) })
      })
    }, 20000)
  },


  async UPDATE_TIP_DELAYED ({ commit }, { tipId, updatedFields }) {
    setTimeout(() => {
      return new Promise((resolve, reject) => {
        tipsCollection.doc(tipId).update(
          updatedFields
        )
          .then((response) => {
            commit('UPDATE_TIP', {tipId, updatedFields})
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    }, 300)
  },

  async UPDATE_TIP ({ commit }, { tipId, updatedFields }) {
    if (process.env.VUE_APP_EXPLORATION_MODE) { return }

    return new Promise((resolve, reject) => {
      tipsCollection.doc(tipId).update(
        updatedFields
      )
        .then((response) => {
          commit('UPDATE_TIP', {tipId, updatedFields})
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
